<ng-container *ngIf="productListService.countDetails$|async as countDetails">
  <ng-container *ngIf="$any(countDetails)?.productModel?.productsCounts==0 && $any(countDetails)?.crossRefModel?.crossRefCounts==0 && $any(countDetails)?.softwareModel?.softwareCounts==0
    && $any(countDetails)?.docModel?.documentsCounts==0; else matTabData">
    <div class="noData">
      <div class=" searchEmptyPageMiddle">
        <div class="content">
          <cx-page-slot position="MiddleContent-notFound"></cx-page-slot>
        </div>
      </div>
      <div class="search-empty">
        <button class="btn btn-block btn-primary btn-searchempty continue-btn"
          [routerLink]="{ cxRoute: 'home' } | cxUrl">
          {{'common.general_continue_shopping'|cxTranslate}}
          <img src="/icons/link-white.svg" class="icon-right" alt="">
        </button>
      </div>

    </div>
  </ng-container>

  <ng-template #matTabData>
    <div class="tabs" *ngIf="!isMobile">
      <mat-tab-group (selectedTabChange)="tabClickHandle($event, countDetails)" [selectedIndex]="selectedTabIndex"
        animationDuration="0ms">
        <div class="cx-page">
          <mat-tab [disabled]="$any(countDetails)?.productModel.productsCounts==0"
            label="{{'common.search_page_product'|cxTranslate}} ({{$any(countDetails)?.productModel.productsCounts}})">
            <section tabindex="-1" class="cx-page-section">
              <div class="container1">
                <div class="row1">
                  <ng-container *ngIf="viewMode$ | async as viewMode">
                    <div class="row1">
                      <h1 class="search-text">{{'common.search_page_searchText'|cxTranslate}}
                        <label class="searchTerm" [innerHTML]="searchQuery|searchHighlight:searchQuery"></label>
                      </h1>
                    </div>
                    <div class="cx-sorting top">
                      <div class="action-row sorting-block">
                        <label
                          class="col-lg-3 total-result pagination">{{$any(countDetails)?.productModel.formattedProductsCounts}}
                          {{'common.search_page_totalResults'|cxTranslate}}</label>
                        <label class="col-lg-3 pagination" [style.visibility]="(
                          $any(countDetails)?.productModel.pagination.totalResults >90 || 
                          $any(countDetails)?.productModel.pagination.totalResults >30) ? 'visible' : 'hidden'">


                          {{'common.pagination_view'|cxTranslate}} <a
                            *ngIf="$any(countDetails)?.productModel.pagination.totalResults >30" class="page-size"
                            [routerLink]="" (click)="changePageSize(30, $any(countDetails)?.productModel)">
                            &nbsp;30&nbsp;</a> <span
                            *ngIf="$any(countDetails)?.productModel.pagination.totalResults >90">{{'common.pagination_or'|cxTranslate}}
                            <a class="page-size" [routerLink]=""
                              (click)="changePageSize(90,  $any(countDetails)?.productModel)">&nbsp;90&nbsp;</a></span>
                          {{'common.pagination_items'|cxTranslate}}</label>

                        <div class="col-lg-3">
                          <div class="sort-section-prod d-flex align-items-center w-100">
                            <label class="sort-by">
                              <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                            </label>
                            <div class="sorting flex-grow-1">
                              <cx-sorting [sortOptions]="$any(countDetails)?.productModel?.sorts"
                                (sortListEvent)="sortListProduct($event, $any(countDetails)?.productModel)"
                                [selectedOption]="$any(countDetails)?.productModel?.pagination?.sort"
                                ariaControls="product-results-list">
                              </cx-sorting>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-lg-3 no-padding mode-change d-sm-none d-lg-flex justify-content-end product-view-btn">
                          <cx-product-view (modeChange)="setViewMode($event)" [mode]="viewMode"></cx-product-view>
                        </div>
                      </div>
                    </div>
                    <div id="product-results-list" class="cx-product-container">
                      <!-- Product list when using pagination -->
                      <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">

                        <ng-container *ngIf="viewMode === ViewModes.Grid || isMobile">
                          <div class="row">
                            <app-kb-product-grid-item *ngFor="let product of $any(countDetails)?.productModel?.products"
                              [product]="product" [searchQuery]="searchQuery"
                              class="col-12 col-sm-12 col-md-12 col-lg-3 sm-view product-grid-item"
                              [ngClass]="isLoggedIn ? 'user-logged':'user-not-logged'"></app-kb-product-grid-item>
                          </div>
                        </ng-container>

                        <ng-container *ngIf="viewMode === ViewModes.List && !isMobile">
                          <app-kb-product-list-item *ngFor="let product of $any(countDetails)?.productModel?.products"
                            [product]="product" [searchQuery]="searchQuery"
                            class="cx-product-search-list"></app-kb-product-list-item>
                        </ng-container>
                      </ng-container>

                      <!-- Product list when using infinite scroll -->
                      <ng-template #infiniteScroll>
                        <cx-product-scroll [scrollConfig]="scrollConfig" [model]="$any(countDetails)?.productModel"
                          [inputViewMode]="viewMode"></cx-product-scroll>
                      </ng-template>
                    </div>
                    <div class="cx-sorting bottom">
                      <div class="row col-md-12">
                        <label class="col-md-5">{{'common.search_page_showing_text'|cxTranslate}}
                          {{($any(countDetails)?.productModel.pagination.pageSize *
                          $any(countDetails)?.productModel.pagination.currentPage)+1 }}-
                          <span
                            *ngIf="$any(countDetails)?.productModel.pagination.pageSize *($any(countDetails)?.productModel.pagination.currentPage+1) < $any(countDetails)?.productModel.pagination.totalResults">{{$any(countDetails)?.productModel.pagination.pageSize
                            *($any(countDetails)?.productModel.pagination.currentPage+1)}}</span>
                          <span
                            *ngIf="$any(countDetails)?.productModel.pagination.pageSize *($any(countDetails)?.productModel.pagination.currentPage+1) > $any(countDetails)?.productModel.pagination.totalResults">{{$any(countDetails)?.productModel.pagination.totalResults}}</span>
                          {{'common.search_page_of_text'|cxTranslate}}
                          {{$any(countDetails)?.productModel.formattedProductsCounts}}
                          {{'common.search_page_result_text'|cxTranslate}}</label>
                        <div *ngIf="!isInfiniteScroll"
                          class="col-auto col-md-7 d-flex justify-content-end align-items-center pr">
                          <div class="kb-pagination">
                            <kb-pagination [pagination]="$any(countDetails)?.productModel.pagination" [defaultPage]="0"
                              (viewPageEvent)="changePageCustom($event, $any(countDetails)?.productModel, 0)"></kb-pagination>
                          </div>
                        </div>

                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </section>
          </mat-tab>
          <mat-tab [disabled]="$any(countDetails)?.crossRefModel?.crossRefCounts==0"
            label="{{'common.search_page_product_cross_reference'|cxTranslate}} ({{$any(countDetails)?.crossRefModel?.crossRefCounts}})">
            <section tabindex="-1" class="cx-page-section"
              [attr.aria-label]="'productList.productListResults' | cxTranslate">
              <div class="container1">
                <div class="row1">
                  <ng-container *ngIf="$any(countDetails)?.crossRefModel?.crossRefCounts">
                    <ng-container *ngIf="viewMode$ | async as viewMode">
                      <div class="row1">
                        <h1 class="search-text">{{'common.search_page_searchText'|cxTranslate}}
                          <label class="searchTerm" [innerHTML]="searchQuery|searchHighlight:searchQuery"></label>
                        </h1>
                      </div>
                      <div class="cx-sorting top">
                        <div class="action-row sorting-block">
                          <label
                            class="col-lg-3 total-result pagination">{{$any(countDetails)?.crossRefModel.formattedCrossRefCounts}}
                            {{'common.search_page_totalResults'|cxTranslate}}</label>
                          <label class="col-lg-3 pagination"
                            [style.visibility]="(
                            $any(countDetails)?.crossRefModel.pagination.totalResults >90 || 
                            $any(countDetails)?.crossRefModel.pagination.totalResults >30) ? 'visible' : 'hidden'">{{'common.pagination_view'|cxTranslate}}
                            <a *ngIf="$any(countDetails)?.crossRefModel.pagination.totalResults >30" class="page-size"
                              [routerLink]="" (click)="changePageSize(30, $any(countDetails)?.crossRefModel)">
                              &nbsp;30&nbsp;</a> <span
                              *ngIf="$any(countDetails)?.crossRefModel.pagination.totalResults >90">{{'common.pagination_or'|cxTranslate}}
                              <a class="page-size" [routerLink]=""
                                (click)="changePageSize(90,  $any(countDetails)?.crossRefModel)">&nbsp;90&nbsp;</a></span>
                            {{'common.pagination_items'|cxTranslate}}</label>

                          <!--   <div class="sort-section">
                            <label class="sort-by">
                              <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                            </label>
                            <div class="col-lg-3 sorting">
                              <cx-sorting [sortOptions]="$any(countDetails)?.crossRefModel.sorts"
                                (sortListEvent)="sortListCrossRef($event, $any(countDetails)?.crossRefModel)"
                                [selectedOption]="$any(countDetails)?.crossRefModel.pagination?.sort"
                                [ariaLabel]="'productList.sortResults' | cxTranslate"
                                ariaControls="product-results-list"
                                placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                              </cx-sorting>
                            </div>
                          </div> -->
                          <div class="col-lg-3">
                            <div class="sort-section-prod d-flex align-items-center w-100">
                              <label class="sort-by">
                                <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                              </label>
                              <div class="sorting flex-grow-1">
                                <cx-sorting [sortOptions]="$any(countDetails)?.productModel?.sorts"
                                  (sortListEvent)="sortListProduct($event, $any(countDetails)?.productModel)"
                                  [selectedOption]="$any(countDetails)?.productModel?.pagination?.sort"
                                  ariaControls="product-results-list">
                                </cx-sorting>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 no-padding d-flex justify-content-end">
                            <cx-product-view (modeChange)="setViewMode($event)" [mode]="viewMode"></cx-product-view>
                          </div>
                        </div>
                      </div>
                      <div id="product-results-list" class="cx-product-container">
                        <!-- Product list when using pagination -->
                        <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">

                          <ng-container *ngIf="viewMode === ViewModes.Grid || isMobile">
                            <div class="row">
                              <app-kb-cross-ref-grid-item
                                *ngFor="let product of $any(countDetails)?.crossRefModel?.products" [product]="product"
                                [searchQuery]="searchQuery"
                                class="col-12 col-sm-12 col-md-12 col-lg-3 sm-view product-grid-item cross-ref-grid-item"
                                [ngClass]="isLoggedIn ? 'user-logged':'user-not-logged'"></app-kb-cross-ref-grid-item>
                            </div>
                          </ng-container>

                          <ng-container *ngIf="viewMode === ViewModes.List && !isMobile">
                            <app-kb-cross-ref-list-item
                              *ngFor="let product of $any(countDetails)?.crossRefModel?.products" [product]="product"
                              [searchQuery]="searchQuery" class="cx-product-search-list">
                            </app-kb-cross-ref-list-item>
                          </ng-container>
                        </ng-container>

                        <!-- Product list when using infinite scroll -->
                        <ng-template #infiniteScroll>
                          <cx-product-scroll [scrollConfig]="scrollConfig" [model]="$any(countDetails)?.crossRefModel"
                            [inputViewMode]="viewMode"></cx-product-scroll>
                        </ng-template>
                      </div>
                      <div class="cx-sorting bottom">
                        <div class="row col-md-12">
                          <label class="col-md-5">{{'common.search_page_showing_text'|cxTranslate}}
                            {{($any(countDetails)?.crossRefModel.pagination.pageSize *
                            $any(countDetails)?.crossRefModel.pagination.currentPage)+1 }}-
                            <span
                              *ngIf="$any(countDetails)?.crossRefModel.pagination.pageSize *($any(countDetails)?.crossRefModel.pagination.currentPage+1) < $any(countDetails)?.crossRefModel.pagination.totalResults">{{$any(countDetails)?.crossRefModel.pagination.pageSize
                              *($any(countDetails)?.crossRefModel.pagination.currentPage+1)}}</span>
                            <span
                              *ngIf="$any(countDetails)?.crossRefModel.pagination.pageSize *($any(countDetails)?.crossRefModel.pagination.currentPage+1) > $any(countDetails)?.crossRefModel.pagination.totalResults">{{$any(countDetails)?.crossRefModel.pagination.totalResults}}</span>
                            {{'common.search_page_of_text'|cxTranslate}}
                            {{$any(countDetails)?.crossRefModel.formattedCrossRefCounts}}
                            {{'common.search_page_result_text'|cxTranslate}}</label>
                          <div *ngIf="!isInfiniteScroll"
                            class="col-auto col-md-7 d-flex justify-content-end align-items-center pr"
                            [attr.aria-label]="
                      'productList.productSearchPagination' | cxTranslate
                    ">
                            <div class="kb-pagination">
                              <kb-pagination [pagination]="$any(countDetails)?.crossRefModel.pagination"
                                [defaultPage]="0"
                                (viewPageEvent)="changePageCustom($event, $any(countDetails)?.crossRefModel, 1)"></kb-pagination>
                            </div>
                          </div>

                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </section>
          </mat-tab>
          <mat-tab [disabled]="$any(countDetails)?.docModel?.documentsCounts==0"
            label="Documents ({{$any(countDetails)?.docModel?.documentsCounts}})">
            <section tabindex="-1" class="cx-page-section"
              [attr.aria-label]="'productList.productListResults' | cxTranslate">
              <div class="container1">
                <div class="row1" *ngIf="$any(countDetails)?.docModel?.documentsCounts">
                  <div class="" *ngIf="viewMode$ | async as viewMode">
                    <div class="row1">
                      <label class="search-text">{{'common.search_page_searchText'|cxTranslate}}
                        <span class="searchTerm" [innerHTML]="searchQuery|searchHighlight:searchQuery"></span></label>
                    </div>
                    <div class="cx-sorting top">
                      <div class="action-row sorting-block">
                        <label
                          class="d-none d-md-none d-lg-block col-lg-3 total-records">{{$any(countDetails)?.docModel.pagination.totalResults}}
                          {{'common.search_page_totalResults'|cxTranslate}}</label>
                        <label class="col-lg-3 pagination"
                          *ngIf="$any(countDetails)?.docModel.pagination.totalResults >90 || $any(countDetails)?.docModel.pagination.totalResults >30">{{'common.pagination_view'|cxTranslate}}
                          <a *ngIf="$any(countDetails)?.docModel.pagination.totalResults >30" class="page-size"
                            [routerLink]="" (click)="changePageSize(30,  $any(countDetails)?.docModel)"> &nbsp;30&nbsp;
                          </a> <span
                            *ngIf="$any(countDetails)?.docModel.pagination.totalResults >90">{{'common.pagination_or'|cxTranslate}}
                            <a class="page-size" [routerLink]=""
                              (click)="changePageSize(90, $any(countDetails)?.docModel)">&nbsp;90&nbsp;</a></span>
                          {{'common.pagination_items'|cxTranslate}}</label>

                        <div class="sort-section">
                          <label class="sort-by">
                            <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                          </label>
                          <div class="col-lg-4 sorting">
                            <cx-sorting [sortOptions]="$any(countDetails)?.docModel.sorts"
                              (sortListEvent)="sortListDocs($event, $any(countDetails)?.docModel)"
                              [selectedOption]="$any(countDetails)?.docModel.pagination?.sort"
                              [ariaLabel]="'productList.sortResults' | cxTranslate" ariaControls="product-results-list"
                              placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                            </cx-sorting>
                          </div>
                        </div>
                        <div class="col-lg-1 no-padding d-flex justify-content-end switch-btn">
                          <cx-product-view (modeChange)="setViewMode($event)" [mode]="viewMode"></cx-product-view>
                        </div>
                      </div>
                    </div>
                    <div id="product-results-list" class="cx-product-container">
                      <!-- Product list when using pagination -->
                      <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">

                        <ng-container *ngIf="viewMode === ViewModes.Grid">
                          <div class="row">
                            <app-kb-document-grid *ngFor="let product of $any(countDetails)?.docModel?.documents"
                              [product]="product" [searchQuery]="searchQuery"
                              class="col-12 col-sm-6 col-md-3"></app-kb-document-grid>
                          </div>
                        </ng-container>

                        <ng-container *ngIf="viewMode === ViewModes.List">
                          <app-kb-document-list *ngFor="let product of $any(countDetails)?.docModel?.documents"
                            [product]="product" [searchQuery]="searchQuery" class="cx-product-search-list">
                          </app-kb-document-list>
                        </ng-container>
                      </ng-container>

                      <!-- Product list when using infinite scroll -->
                      <ng-template #infiniteScroll>
                        <cx-product-scroll [scrollConfig]="scrollConfig" [model]="$any(countDetails)?.docModel"
                          [inputViewMode]="viewMode"></cx-product-scroll>
                      </ng-template>
                    </div>
                    <div class="cx-sorting bottom">
                      <div class="row col-md-12">
                        <label class="col-md-5">{{'common.search_page_showing_text'|cxTranslate}}
                          {{($any(countDetails)?.docModel.pagination.pageSize *
                          $any(countDetails)?.docModel.pagination.currentPage)+1 }}-
                          <span
                            *ngIf="$any(countDetails)?.docModel.pagination.pageSize *($any(countDetails)?.docModel.pagination.currentPage+1) < $any(countDetails)?.docModel.pagination.totalResults">{{$any(countDetails)?.docModel.pagination.pageSize
                            *($any(countDetails)?.docModel.pagination.currentPage+1)}}</span>
                          <span
                            *ngIf="$any(countDetails)?.docModel.pagination.pageSize *($any(countDetails)?.docModel.pagination.currentPage+1) > $any(countDetails)?.docModel.pagination.totalResults">{{$any(countDetails)?.docModel.pagination.totalResults}}</span>
                          {{'common.search_page_of_text'|cxTranslate}}
                          {{$any(countDetails)?.docModel.pagination.totalResults}}
                          {{'common.search_page_result_text'|cxTranslate}}</label>
                        <div *ngIf="!isInfiniteScroll"
                          class="col-auto col-md-7 d-flex justify-content-end align-items-center pr" [attr.aria-label]="
                        'productList.productSearchPagination' | cxTranslate
                      ">
                          <div class="kb-pagination">
                            <kb-pagination [pagination]="$any(countDetails)?.docModel.pagination" [defaultPage]="0"
                              (viewPageEvent)="changePageCustom($event, $any(countDetails)?.docModel,2)"></kb-pagination>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </mat-tab>
          <mat-tab [disabled]="$any(countDetails)?.softwareModel?.softwareCounts==0"
            label="{{'common.search_page_software'|cxTranslate}} ({{$any(countDetails)?.softwareModel?.softwareCounts}})">
            <section tabindex="-1" class="cx-page-section">
              <div class="container1">
                <div class="row1" *ngIf="$any(countDetails)?.softwareModel">
                  <div class="" *ngIf="viewMode$ | async as viewMode">
                    <div class="row1">
                      <label class="search-text">{{'common.search_page_searchText'|cxTranslate}}
                        <span class="searchTerm" [innerHTML]="searchQuery|searchHighlight:searchQuery"></span></label>
                    </div>
                    <div class="cx-sorting top">
                      <div class="action-row sorting-block">
                        <label
                          class="d-none d-md-none d-lg-block col-lg-3 total-records">{{$any(countDetails)?.softwareModel.pagination.totalResults}}
                          {{'common.search_page_totalResults'|cxTranslate}}</label>
                        <label
                          *ngIf="$any(countDetails)?.softwareModel.pagination.totalResults >90 || $any(countDetails)?.softwareModel.pagination.totalResults >30"
                          class="col-lg-3 pagination">{{'common.pagination_view'|cxTranslate}} <a
                            *ngIf="$any(countDetails)?.softwareModel.pagination.totalResults >30" class="page-size"
                            [routerLink]="" (click)="changePageSize(30, $any(countDetails)?.softwareModel)">
                            &nbsp;30&nbsp;</a> <span
                            *ngIf="$any(countDetails)?.softwareModel.pagination.totalResults >90">{{'common.pagination_or'|cxTranslate}}
                            <a class="page-size" [routerLink]=""
                              (click)="changePageSize(90, $any(countDetails)?.softwareModel)">&nbsp;90&nbsp;</a></span>
                          {{'common.pagination_items'|cxTranslate}}</label>

                        <div class="sort-section">
                          <label class="sort-by">
                            <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                          </label>
                          <div class="col-lg-3 sorting">
                            <cx-sorting [sortOptions]="$any(countDetails)?.softwareModel.sorts"
                              (sortListEvent)="sortListSoftware($event, $any(countDetails)?.softwareModel)"
                              [selectedOption]="$any(countDetails)?.softwareModel.pagination?.sort"
                              ariaControls="product-results-list">
                            </cx-sorting>
                          </div>
                        </div>
                        <div class="col-lg-2 no-padding d-flex justify-content-end">
                          <cx-product-view (modeChange)="setViewMode($event)" [mode]="viewMode"></cx-product-view>
                        </div>
                      </div>
                    </div>
                    <div id="product-results-list" class="cx-product-container">
                      <!-- Product list when using pagination -->
                      <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">

                        <ng-container *ngIf="viewMode === ViewModes.Grid || isMobile">
                          <div class="row">
                            <app-kb-software-grid-item
                              *ngFor="let product of $any(countDetails)?.softwareModel?.softwares" [product]="product"
                              [searchQuery]="searchQuery"
                              class="col-12 col-sm-12 col-md-12 col-lg-3"></app-kb-software-grid-item>
                          </div>
                        </ng-container>

                        <ng-container *ngIf="viewMode === ViewModes.List && !isMobile">
                          <app-kb-software-list-item
                            *ngFor="let product of $any(countDetails)?.softwareModel?.softwares" [product]="product"
                            [searchQuery]="searchQuery" class="cx-product-search-list">
                          </app-kb-software-list-item>
                        </ng-container>
                      </ng-container>

                      <!-- Product list when using infinite scroll -->
                      <ng-template #infiniteScroll>
                        <cx-product-scroll [scrollConfig]="scrollConfig" [model]="$any(countDetails)?.softwareModel"
                          [inputViewMode]="viewMode"></cx-product-scroll>
                      </ng-template>
                    </div>
                    <div class="cx-sorting bottom">
                      <div class="row col-md-12">
                        <label class="col-md-5">{{'common.search_page_showing_text'|cxTranslate}}
                          {{($any(countDetails)?.softwareModel.pagination.pageSize *
                          $any(countDetails)?.softwareModel.pagination.currentPage)+1 }}-
                          <span
                            *ngIf="$any(countDetails)?.softwareModel.pagination.pageSize *($any(countDetails)?.softwareModel.pagination.currentPage+1) < $any(countDetails)?.softwareModel.pagination.totalResults">{{$any(countDetails)?.softwareModel.pagination.pageSize
                            *($any(countDetails)?.softwareModel.pagination.currentPage+1)}}</span>
                          <span
                            *ngIf="$any(countDetails)?.softwareModel.pagination.pageSize *($any(countDetails)?.softwareModel.pagination.currentPage+1) > $any(countDetails)?.softwareModel.pagination.totalResults">{{$any(countDetails)?.softwareModel.pagination.totalResults}}</span>
                          {{'common.search_page_of_text'|cxTranslate}}
                          {{$any(countDetails)?.softwareModel.pagination.totalResults}}
                          {{'common.search_page_result_text'|cxTranslate}}</label>
                        <div *ngIf="!isInfiniteScroll"
                          class="col-auto col-md-7 d-flex justify-content-end align-items-center pr">
                          <div class="kb-pagination">
                            <kb-pagination [pagination]="$any(countDetails)?.softwareModel.pagination" [defaultPage]="0"
                              (viewPageEvent)="changePageCustom($event, $any(countDetails)?.softwareModel,3)"></kb-pagination>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </mat-tab>
        </div>
      </mat-tab-group>
    </div>

    <div *ngIf="isMobile">
      <div class="tabs-button-group">
        <button class="tab-button" [class.active]="selectedTabIndex===0" (click)="selectTab(0)"
          [disabled]="$any(countDetails)?.productModel.productsCounts==0"
          [ngClass]="{'tab-button-active': selectedTabIndex === 0}">
          {{'common.search_page_product'|cxTranslate}} ({{$any(countDetails)?.productModel.productsCounts}})
        </button>
        <button class="tab-button" [class.active]="selectedTabIndex===1" (click)="selectTab(1)"
          [disabled]="$any(countDetails)?.crossRefModel?.crossRefCounts==0"
          [ngClass]="{'tab-button-active': selectedTabIndex === 1}">
          {{'common.search_page_product_cross_reference'|cxTranslate}}
          ({{$any(countDetails)?.crossRefModel?.crossRefCounts}})
        </button>
        <button class="tab-button" [class.active]="selectedTabIndex===2" (click)="selectTab(2)"
          [disabled]="$any(countDetails)?.docModel?.documentsCounts==0"
          [ngClass]="{'tab-button-active': selectedTabIndex === 2}">
          Documents ({{$any(countDetails)?.docModel?.documentsCounts}})
        </button>
        <button class="tab-button" [class.active]="selectedTabIndex===3" (click)="selectTab(3)"
          [disabled]="$any(countDetails)?.softwareModel?.softwareCounts==0"
          [ngClass]="{'tab-button-active': selectedTabIndex ===3}">
          {{'common.search_page_software'|cxTranslate}} ({{$any(countDetails)?.softwareModel?.softwareCounts}})
        </button>
      </div>
      <div class="tabs">
        <div *ngIf="selectedTabIndex===0">
          <div class="container1">
            <div class="row1">
              <div class="" *ngIf="viewMode$ | async as viewMode">
                <div class="row1">
                  <label class="search-text">{{'common.search_page_searchText'|cxTranslate}} <span class="searchTerm"
                      [innerHTML]="searchQuery|searchHighlight:searchQuery"></span></label>
                </div>
                <div class="cx-sorting top">
                  <div class="action-row sorting-block">
                    <label
                      class="col-lg-3 total-result pagination">{{$any(countDetails)?.productModel.formattedProductsCounts}}
                      {{'common.search_page_totalResults'|cxTranslate}}</label>
                    <label class="col-lg-3 pagination">{{'common.pagination_view'|cxTranslate}} <a class="page-size"
                        [routerLink]="" (click)="changePageSize(30, $any(countDetails)?.productModel)"> &nbsp;30&nbsp;
                      </a> {{'common.pagination_or'|cxTranslate}} <a class="page-size" [routerLink]=""
                        (click)="changePageSize(90, $any(countDetails)?.productModel)">&nbsp;90&nbsp;</a>
                      {{'common.pagination_items'|cxTranslate}}</label>

                    <span class="facetForMobile">
                      <app-facet-navigation></app-facet-navigation>
                    </span>

                    <div class="sort-section">
                      <label class="sort-by">
                        <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                      </label>

                      <div class="col-lg-3 sorting">
                        <cx-sorting [sortOptions]="$any(countDetails)?.productModel.sorts"
                          (sortListEvent)="sortListProduct($event, $any(countDetails)?.productModel)"
                          [selectedOption]="$any(countDetails)?.productModel.pagination?.sort"
                          ariaControls="product-results-list">
                        </cx-sorting>
                      </div>
                    </div>

                  </div>
                </div>
                <div id="product-results-list" class="cx-product-container">
                  <!-- Product list when using pagination -->
                  <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">

                    <ng-container *ngIf="viewMode === ViewModes.Grid || isMobile">
                      <div class="row">
                        <app-kb-product-grid-item *ngFor="let product of $any(countDetails)?.productModel?.products"
                          [product]="product" [searchQuery]="searchQuery"
                          class="col-12 col-sm-12 col-md-12 col-lg-3 sm-view product-grid-item"
                          [ngClass]="isLoggedIn ? 'user-logged':'user-not-logged'"></app-kb-product-grid-item>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="viewMode === ViewModes.List && !isMobile">
                      <app-kb-product-list-item *ngFor="let product of $any(countDetails)?.productModel?.products"
                        [product]="product" [searchQuery]="searchQuery"
                        class="cx-product-search-list"></app-kb-product-list-item>
                    </ng-container>
                  </ng-container>

                  <!-- Product list when using infinite scroll -->
                  <ng-template #infiniteScroll>
                    <cx-product-scroll [scrollConfig]="scrollConfig" [model]="$any(countDetails)?.productModel"
                      [inputViewMode]="viewMode"></cx-product-scroll>
                  </ng-template>
                </div>
                <div class="cx-sorting bottom">
                  <div class="row col-md-12">
                    <label class="col-md-5">{{'common.search_page_showing_text'|cxTranslate}}
                      {{($any(countDetails)?.productModel.pagination.pageSize *
                      $any(countDetails)?.productModel.pagination.currentPage)+1 }}-
                      <span
                        *ngIf="$any(countDetails)?.productModel.pagination.pageSize *($any(countDetails)?.productModel.pagination.currentPage+1) < $any(countDetails)?.productModel.pagination.totalResults">{{$any(countDetails)?.productModel.pagination.pageSize
                        *($any(countDetails)?.productModel.pagination.currentPage+1)}}</span>
                      <span
                        *ngIf="$any(countDetails)?.productModel.pagination.pageSize *($any(countDetails)?.productModel.pagination.currentPage+1) > $any(countDetails)?.productModel.pagination.totalResults">{{$any(countDetails)?.productModel.pagination.totalResults}}</span>
                      {{'common.search_page_of_text'|cxTranslate}}
                      {{$any(countDetails)?.productModel.formattedProductsCounts}}
                      {{'common.search_page_result_text'|cxTranslate}}</label>
                    <div *ngIf="!isInfiniteScroll"
                      class="col-auto col-md-7 d-flex justify-content-end align-items-center pr">
                      <div class="kb-pagination">
                        <kb-pagination [pagination]="$any(countDetails)?.productModel.pagination" [defaultPage]="0"
                          (viewPageEvent)="changePageCustom($event, $any(countDetails)?.productModel, 0)"></kb-pagination>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="selectedTabIndex===1">
          <div class="container1">
            <div class="row1" *ngIf="$any(countDetails)?.crossRefModel?.crossRefCounts">
              <div class="" *ngIf="viewMode$ | async as viewMode">
                <div class="row1">
                  <label class="search-text">{{'common.search_page_searchText'|cxTranslate}} <span class="searchTerm"
                      [innerHTML]="searchQuery|searchHighlight:searchQuery"></span></label>
                </div>
                <div class="cx-sorting top">
                  <div class="action-row sorting-block">
                    <label
                      class="d-none d-md-none d-lg-block col-lg-3 total-records">{{$any(countDetails)?.crossRefModel.formattedCrossRefCounts}}
                      {{'common.search_page_totalResults'|cxTranslate}}</label>
                    <label
                      *ngIf="$any(countDetails)?.crossRefModel.pagination.totalResults >90 || $any(countDetails)?.crossRefModel.pagination.totalResults >30"
                      class="col-lg-3 pagination">{{'common.pagination_view'|cxTranslate}} <a
                        *ngIf="$any(countDetails)?.crossRefModel.pagination.totalResults >30" class="page-size"
                        [routerLink]="" (click)="changePageSize(30, $any(countDetails)?.crossRefModel)">
                        &nbsp;30&nbsp;</a> <span
                        *ngIf="$any(countDetails)?.crossRefModel.pagination.totalResults >90">{{'common.pagination_or'|cxTranslate}}
                        <a class="page-size" [routerLink]=""
                          (click)="changePageSize(90,  $any(countDetails)?.crossRefModel)">&nbsp;90&nbsp;</a></span>
                      {{'common.pagination_items'|cxTranslate}}</label>
                    <span class="facetForMobile">
                      <app-facet-navigation></app-facet-navigation>
                    </span>
                    <div class="sort-section">
                      <label class="sort-by">
                        <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                      </label>
                      <div class="col-lg-3 sorting">
                        <cx-sorting [sortOptions]="$any(countDetails)?.crossRefModel.sorts"
                          (sortListEvent)="sortListCrossRef($event, $any(countDetails)?.crossRefModel)"
                          [selectedOption]="$any(countDetails)?.crossRefModel.pagination?.sort"
                          [ariaLabel]="'productList.sortResults' | cxTranslate" ariaControls="product-results-list"
                          placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                        </cx-sorting>
                      </div>
                    </div>
                    <div class="col-lg-2 no-padding d-flex justify-content-end">
                      <cx-product-view (modeChange)="setViewMode($event)" [mode]="viewMode"></cx-product-view>
                    </div>
                  </div>
                </div>
                <div id="product-results-list" class="cx-product-container">
                  <!-- Product list when using pagination -->
                  <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">

                    <ng-container *ngIf="viewMode === ViewModes.Grid || isMobile">
                      <div class="row">
                        <app-kb-cross-ref-grid-item *ngFor="let product of $any(countDetails)?.crossRefModel?.products"
                          [product]="product" [searchQuery]="searchQuery"
                          class="col-12 col-sm-12 col-md-12 col-lg-3 sm-view product-grid-item cross-ref-grid-item"
                          [ngClass]="isLoggedIn ? 'user-logged':'user-not-logged'"></app-kb-cross-ref-grid-item>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="viewMode === ViewModes.List && !isMobile">
                      <app-kb-cross-ref-list-item *ngFor="let product of $any(countDetails)?.crossRefModel?.products"
                        [product]="product" [searchQuery]="searchQuery" class="cx-product-search-list">
                      </app-kb-cross-ref-list-item>
                    </ng-container>
                  </ng-container>

                  <!-- Product list when using infinite scroll -->
                  <ng-template #infiniteScroll>
                    <cx-product-scroll [scrollConfig]="scrollConfig" [model]="$any(countDetails)?.crossRefModel"
                      [inputViewMode]="viewMode"></cx-product-scroll>
                  </ng-template>
                </div>
                <div class="cx-sorting bottom">
                  <div class="row col-md-12">
                    <label class="col-md-5">{{'common.search_page_showing_text'|cxTranslate}}
                      {{($any(countDetails)?.crossRefModel.pagination.pageSize *
                      $any(countDetails)?.crossRefModel.pagination.currentPage)+1 }}-
                      <span
                        *ngIf="$any(countDetails)?.crossRefModel.pagination.pageSize *($any(countDetails)?.crossRefModel.pagination.currentPage+1) < $any(countDetails)?.crossRefModel.pagination.totalResults">{{$any(countDetails)?.crossRefModel.pagination.pageSize
                        *($any(countDetails)?.crossRefModel.pagination.currentPage+1)}}</span>
                      <span
                        *ngIf="$any(countDetails)?.crossRefModel.pagination.pageSize *($any(countDetails)?.crossRefModel.pagination.currentPage+1) > $any(countDetails)?.crossRefModel.pagination.totalResults">{{$any(countDetails)?.crossRefModel.pagination.totalResults}}</span>
                      {{'common.search_page_of_text'|cxTranslate}}
                      {{$any(countDetails)?.crossRefModel.formattedCrossRefCounts}}
                      {{'common.search_page_result_text'|cxTranslate}}</label>
                    <div *ngIf="!isInfiniteScroll"
                      class="col-auto col-md-7 d-flex justify-content-end align-items-center pr" [attr.aria-label]="
                  'productList.productSearchPagination' | cxTranslate
                ">
                      <div class="kb-pagination">
                        <kb-pagination [pagination]="$any(countDetails)?.crossRefModel.pagination" [defaultPage]="0"
                          (viewPageEvent)="changePageCustom($event, $any(countDetails)?.crossRefModel, 1)"></kb-pagination>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="selectedTabIndex===2">
          <div class="container1">
            <div class="row1" *ngIf="$any(countDetails)?.docModel?.documentsCounts">
              <div class="" *ngIf="viewMode$ | async as viewMode">
                <div class="row1">
                  <label class="search-text">{{'common.search_page_searchText'|cxTranslate}}
                    <span class="searchTerm" [innerHTML]="searchQuery|searchHighlight:searchQuery"></span></label>
                </div>
                <div class="cx-sorting top">
                  <div class="action-row sorting-block">
                    <label
                      class="d-none d-md-none d-lg-block col-lg-3 total-records">{{$any(countDetails)?.docModel.pagination.totalResults}}
                      {{'common.search_page_totalResults'|cxTranslate}}</label>
                    <label class="col-lg-3 pagination"
                      *ngIf="$any(countDetails)?.docModel.pagination.totalResults >90 || $any(countDetails)?.docModel.pagination.totalResults >30">{{'common.pagination_view'|cxTranslate}}
                      <a *ngIf="$any(countDetails)?.docModel.pagination.totalResults >30" class="page-size"
                        [routerLink]="" (click)="changePageSize(30,  $any(countDetails)?.docModel)"> &nbsp;30&nbsp;
                      </a> <span
                        *ngIf="$any(countDetails)?.docModel.pagination.totalResults >90">{{'common.pagination_or'|cxTranslate}}
                        <a class="page-size" [routerLink]=""
                          (click)="changePageSize(90, $any(countDetails)?.docModel)">&nbsp;90&nbsp;</a></span>
                      {{'common.pagination_items'|cxTranslate}}</label>
                    <span class="facetForMobile facet-for-documents">
                      <app-facet-navigation></app-facet-navigation>
                    </span>
                    <div class="sort-section">
                      <label class="sort-by">
                        <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                      </label>
                      <div class="col-lg-4 sorting">
                        <cx-sorting [sortOptions]="$any(countDetails)?.docModel.sorts"
                          (sortListEvent)="sortListDocs($event, $any(countDetails)?.docModel)"
                          [selectedOption]="$any(countDetails)?.docModel.pagination?.sort"
                          [ariaLabel]="'productList.sortResults' | cxTranslate" ariaControls="product-results-list"
                          placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                        </cx-sorting>
                      </div>
                    </div>
                    <div class="col-lg-1 no-padding d-flex justify-content-end switch-btn">
                      <cx-product-view (modeChange)="setViewMode($event)" [mode]="viewMode"></cx-product-view>
                    </div>
                  </div>
                </div>
                <div id="product-results-list" class="cx-product-container">
                  <!-- Product list when using pagination -->
                  <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">

                    <ng-container *ngIf="viewMode === ViewModes.Grid">
                      <div class="row">
                        <app-kb-document-grid *ngFor="let product of $any(countDetails)?.docModel?.documents"
                          [product]="product" [searchQuery]="searchQuery"
                          class="col-12 col-sm-6 col-md-3"></app-kb-document-grid>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="viewMode === ViewModes.List">
                      <app-kb-document-list *ngFor="let product of $any(countDetails)?.docModel?.documents"
                        [product]="product" [searchQuery]="searchQuery" class="cx-product-search-list">
                      </app-kb-document-list>
                    </ng-container>
                  </ng-container>

                  <!-- Product list when using infinite scroll -->
                  <ng-template #infiniteScroll>
                    <cx-product-scroll [scrollConfig]="scrollConfig" [model]="$any(countDetails)?.docModel"
                      [inputViewMode]="viewMode"></cx-product-scroll>
                  </ng-template>
                </div>
                <div class="cx-sorting bottom">
                  <div class="row col-md-12">
                    <label class="col-md-5">{{'common.search_page_showing_text'|cxTranslate}}
                      {{($any(countDetails)?.docModel.pagination.pageSize *
                      $any(countDetails)?.docModel.pagination.currentPage)+1 }}-
                      <span
                        *ngIf="$any(countDetails)?.docModel.pagination.pageSize *($any(countDetails)?.docModel.pagination.currentPage+1) < $any(countDetails)?.docModel.pagination.totalResults">{{$any(countDetails)?.docModel.pagination.pageSize
                        *($any(countDetails)?.docModel.pagination.currentPage+1)}}</span>
                      <span
                        *ngIf="$any(countDetails)?.docModel.pagination.pageSize *($any(countDetails)?.docModel.pagination.currentPage+1) > $any(countDetails)?.docModel.pagination.totalResults">{{$any(countDetails)?.docModel.pagination.totalResults}}</span>
                      {{'common.search_page_of_text'|cxTranslate}}
                      {{$any(countDetails)?.docModel.pagination.totalResults}}
                      {{'common.search_page_result_text'|cxTranslate}}</label>
                    <div *ngIf="!isInfiniteScroll"
                      class="col-auto col-md-7 d-flex justify-content-end align-items-center pr" [attr.aria-label]="
                  'productList.productSearchPagination' | cxTranslate
                ">
                      <div class="kb-pagination">
                        <kb-pagination [pagination]="$any(countDetails)?.docModel.pagination" [defaultPage]="0"
                          (viewPageEvent)="changePageCustom($event, $any(countDetails)?.docModel,2)"></kb-pagination>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="selectedTabIndex===3">
          <div class="container1">
            <div class="row1" *ngIf="$any(countDetails)?.softwareModel">
              <div class="" *ngIf="viewMode$ | async as viewMode">
                <div class="row1">
                  <label class="search-text">{{'common.search_page_searchText'|cxTranslate}}
                    <span class="searchTerm" [innerHTML]="searchQuery|searchHighlight:searchQuery"></span></label>
                </div>
                <div class="cx-sorting top">
                  <div class="action-row sorting-block">
                    <label
                      class="d-none d-md-none d-lg-block col-lg-3 total-records">{{$any(countDetails)?.softwareModel.pagination.totalResults}}
                      {{'common.search_page_totalResults'|cxTranslate}}</label>
                    <label
                      *ngIf="$any(countDetails)?.softwareModel.pagination.totalResults >90 || $any(countDetails)?.softwareModel.pagination.totalResults >30"
                      class="col-lg-3 pagination">{{'common.pagination_view'|cxTranslate}} <a
                        *ngIf="$any(countDetails)?.softwareModel.pagination.totalResults >30" class="page-size"
                        [routerLink]="" (click)="changePageSize(30, $any(countDetails)?.softwareModel)">
                        &nbsp;30&nbsp;</a> <span
                        *ngIf="$any(countDetails)?.softwareModel.pagination.totalResults >90">{{'common.pagination_or'|cxTranslate}}
                        <a class="page-size" [routerLink]=""
                          (click)="changePageSize(90, $any(countDetails)?.softwareModel)">&nbsp;90&nbsp;</a></span>
                      {{'common.pagination_items'|cxTranslate}}</label>
                    <ng-container *ngIf="isMobile">
                      <span class="facetForMobile">
                        <app-facet-navigation></app-facet-navigation>
                      </span>
                    </ng-container>
                    <div class="sort-section">
                      <label class="sort-by">
                        <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                      </label>
                      <div class="col-lg-3 sorting">
                        <cx-sorting [sortOptions]="$any(countDetails)?.softwareModel.sorts"
                          (sortListEvent)="sortListSoftware($event, $any(countDetails)?.softwareModel)"
                          [selectedOption]="$any(countDetails)?.softwareModel.pagination?.sort"
                          ariaControls="product-results-list">
                        </cx-sorting>
                      </div>
                    </div>
                    <div class="col-lg-2 no-padding d-flex justify-content-end">
                      <cx-product-view (modeChange)="setViewMode($event)" [mode]="viewMode"></cx-product-view>
                    </div>
                  </div>
                </div>
                <div id="product-results-list" class="cx-product-container">
                  <!-- Product list when using pagination -->
                  <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">

                    <ng-container *ngIf="viewMode === ViewModes.Grid || isMobile">
                      <div class="row">
                        <app-kb-software-grid-item *ngFor="let product of $any(countDetails)?.softwareModel?.softwares"
                          [product]="product" [searchQuery]="searchQuery"
                          class="col-12 col-sm-12 col-md-12 col-lg-3"></app-kb-software-grid-item>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="viewMode === ViewModes.List && !isMobile">
                      <app-kb-software-list-item *ngFor="let product of $any(countDetails)?.softwareModel?.softwares"
                        [product]="product" [searchQuery]="searchQuery" class="cx-product-search-list">
                      </app-kb-software-list-item>
                    </ng-container>
                  </ng-container>

                  <!-- Product list when using infinite scroll -->
                  <ng-template #infiniteScroll>
                    <cx-product-scroll [scrollConfig]="scrollConfig" [model]="$any(countDetails)?.softwareModel"
                      [inputViewMode]="viewMode"></cx-product-scroll>
                  </ng-template>
                </div>
                <div class="cx-sorting bottom">
                  <div class="row col-md-12">
                    <label class="col-md-5">{{'common.search_page_showing_text'|cxTranslate}}
                      {{($any(countDetails)?.softwareModel.pagination.pageSize *
                      $any(countDetails)?.softwareModel.pagination.currentPage)+1 }}-
                      <span
                        *ngIf="$any(countDetails)?.softwareModel.pagination.pageSize *($any(countDetails)?.softwareModel.pagination.currentPage+1) < $any(countDetails)?.softwareModel.pagination.totalResults">{{$any(countDetails)?.softwareModel.pagination.pageSize
                        *($any(countDetails)?.softwareModel.pagination.currentPage+1)}}</span>
                      <span
                        *ngIf="$any(countDetails)?.softwareModel.pagination.pageSize *($any(countDetails)?.softwareModel.pagination.currentPage+1) > $any(countDetails)?.softwareModel.pagination.totalResults">{{$any(countDetails)?.softwareModel.pagination.totalResults}}</span>
                      {{'common.search_page_of_text'|cxTranslate}}
                      {{$any(countDetails)?.softwareModel.pagination.totalResults}}
                      {{'common.search_page_result_text'|cxTranslate}}</label>
                    <div *ngIf="!isInfiniteScroll"
                      class="col-auto col-md-7 d-flex justify-content-end align-items-center pr">
                      <div class="kb-pagination">
                        <kb-pagination [pagination]="$any(countDetails)?.softwareModel.pagination" [defaultPage]="0"
                          (viewPageEvent)="changePageCustom($event, $any(countDetails)?.softwareModel,3)"></kb-pagination>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </ng-template>
  <!-- </ng-container> -->
</ng-container>